import React from 'react';

const AdminCheck = () => {
    return (
        <div>
            <h1>admin check done</h1>
        </div>
    );
};

export default AdminCheck;